var React = require('react');

function IconArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M740.5 730.8l212.1-212.1c3.9-3.9 3.9-10.2 0-14.1L740.5 292.5c-3.9-3.9-10.2-3.9-14.1 0l-31.1 31.1c-3.9 3.9-3.9 10.2 0 14.1l141.5 141.5H74.1c-5.5 0-10 4.5-10 10V534c0 5.5 4.5 10 10 10h762.7L695.3 685.5c-3.9 3.9-3.9 10.2 0 14.1l31.1 31.1c3.9 4 10.2 4 14.1.1z"}));
}

IconArrowRight.displayName = "IconArrowRight";

IconArrowRight.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconArrowRight;

IconArrowRight.default = IconArrowRight;
